import api from './index';
import { fetchReadableStream } from './fetchReadableStream';

const BASE = '/capacityReport';

export const getCapacityReport = async ({
    location,
    dateFrom,
    dateTo,
    plausibilityCheck,
}: {
    location: number;
    dateFrom: string;
    dateTo: string;
    plausibilityCheck: string;
}) => {
    return api.get(BASE, { params: { location, dateFrom, dateTo, plausibilityCheck } }).then((res) => res.data);
};

export const createCapacityReport = async (data: unknown, userId: number, locationId: number) => {
    return api.post(`${BASE}/create`, { data, userId, locationId }).then((res) => res.data);
};

export const getAllCapacityReportsForPeriod = async ({
    dateFrom,
    dateTo,
    location,
}: {
    dateFrom: string;
    dateTo: string;
    location: number;
}) => {
    return api.get(`${BASE}/allForPeriod`, { params: { dateFrom, dateTo, location } }).then((res) => res.data);
};

export const getLastCapacityReportUploadDate = async (location: number): Promise<string> => {
    return api.get(`${BASE}/lastUploadDate`, { params: { location } }).then((res) => res.data);
};

export const getLastCapacityReportUploadUserAndDate = async (
    location: number
): Promise<{ user: string | null; userId: number; date: string }> => {
    return api.get(`${BASE}/lastUploadUserAndDate`, { params: { location } }).then((res) => res.data);
};

export const getLatestCapacityReportByWorktypes = async ({ location, user }: { location: number; user: number }) => {
    return api.get(`${BASE}/latestCapacityReportByWorktypes`, { params: { location, user } }).then((res) => res.data);
};

export const createOneCapacityReport = async (data: unknown) => {
    return api.post(`${BASE}/one`, { data }).then((res) => res.data);
};

export const getLastCapacityReportUploadDatePerLocation = async (location: number) => {
    return api.get(`${BASE}/last-upload-date-per-location`, { params: { location } }).then((res) => res.data);
};

export const getCapacityReportAnalysisByWorktypes = async ({
    location,
    planDate,
    planComparisonDate,
}: {
    location: number;
    planDate: string;
    planComparisonDate: string;
}) => {
    return api.get(`${BASE}/capacityReportAnalysisByWorktypes`, {
        params: { location, planDate, planComparisonDate },
    });
};

export const getCapacityReportAnalysisByChannels = async ({
    location,
    worktype,
    planDate,
    planComparisonDate,
}: {
    location: number;
    worktype: number;
    planDate: string;
    planComparisonDate: string;
}) => {
    return api
        .get(`${BASE}/capacityReportAnalysisByChannels`, {
            params: { location, worktype, planDate, planComparisonDate },
        })
        .then((res) => res.data);
};

export const getCapacityReportAnalysis = async ({
    location,
    worktype,
    channel,
    task,
    capacityType,
    planDate,
    planComparisonDate,
    firstMonthColumnDate,
}: {
    location: number;
    worktype: number;
    channel: number;
    task: number;
    capacityType: number;
    planDate: string;
    planComparisonDate: string;
    firstMonthColumnDate: string;
}) => {
    return api
        .get(`${BASE}/capacityReportAnalysis`, {
            params: {
                location,
                planDate,
                planComparisonDate,
                firstMonthColumnDate,
                worktype,
                channel,
                task,
                capacityType,
            },
        })
        .then((res) => res.data);
};

export const getCapacityReportUploadedDatesInMonth = async ({ location, date }: { location: number; date: string }) => {
    return api.get(`${BASE}/uploadedDatesInMonth`, { params: { location, date } }).then((res) => res.data);
};

export const checkCapacityReportPlausibility = async ({ data, locationId }: { data: unknown; locationId: number }) => {
    return api.post(`${BASE}/checkPlausibility`, { data, locationId }).then((res) => res.data);
};

export const uploadCapacityReports = async ({
    data,
    user,
    setPercentage,
}: {
    data: unknown;
    user: unknown;
    setPercentage: (percentage: number) => void;
}) => {
    return await fetchReadableStream(`${BASE}/upload`, { data, user }, setPercentage);
};
